<div class="grid gap-4">
  @if (!hideLagerplaetze()) { @if (data()?.itemStorage && (data()?.itemStorage?.length ||
  0) > 0) {
  <div class="soft-card">
    <cdk-accordion>
      <cdk-accordion-item
        role="button"
        tabindex="0"
        #accordionItem="cdkAccordionItem"
        [expanded]="lagerplaetzeExpanded()"
        [attr.aria-expanded]="accordionItem.expanded"
        class="flex flex-col"
      >
        <div
          class="font-semibold flex justify-between items-center cursor-pointer"
          (click)="accordionItem.toggle()"
        >
          <h6
            class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide"
          >
            {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK_LOCATIONS.TITLE' | translate }}
          </h6>
          <div
            class="text-light bg-surf rounded-full p-3 cursor-pointer hover:bg-hover"
          >
            @if (!accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
            } @if (accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
            }
          </div>
        </div>
        <div
          [style.display]="accordionItem.expanded ? 'block' : 'none'"
          class="pt-2 bg-surface"
        >
          @for ( stockStorageData of data()?.itemStorage | groupByStock; track
          stockStorageData; let first = $first ) {
          <div
            class="flex flex-col bg-surface"
            [ngClass]="
                        first ? 'border-t border-t-solid border-t-separator' : ''
                      "
          >
            <div
              class="flex px-4 py-2 items-center w-full border-b border-b-solid border-b-separator bg-surface-secondary"
            >
              <div class="w-full text-[0.825rem] font-semibold">
                {{ stockStorageData.stock?.title || stockStorageData.stock?.name }}
              </div>
            </div>
            @for (storage of stockStorageData?.storages; track storage) {
            <div
              class="flex px-4 py-3 items-center justify-between w-full text-sm border-b border-b-solid border-b-separator"
              [class.!bg-success-50]="storage?.kzlagerplatz === 'H'"
            >
              <div>{{ storage.title }} {{ storage?.name }}</div>
            </div>
            }
          </div>
          }
        </div>
      </cdk-accordion-item>
    </cdk-accordion>
  </div>
  } }
  <!-- <div class="flex flex-col mt-5" *ngIf="details?.itemStorage && (details?.itemStorage?.length || 0) > 0">
  <h6 class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide">{{ '#ARTIKELINFO.PAGES.DETAIL.STOCK_LOCATIONS.TITLE' | translate }}</h6>
  <div class="full-width flex flex-col bg-white"
    *ngFor="let stockStorageData of details.itemStorage | groupByStock; let first = first"
    [ngClass]="first ? 'border-t border-t-solid border-t-separator' : ''">
    <div class="flex px-4 py-2 items-center w-full border-b border-b-solid border-b-separator bg-gray-100">
      <div class="w-full text-[0.825rem] font-semibold">{{ stockStorageData.stock?.title || stockStorageData.stock?.name }}</div>
    </div>
    <div *ngFor="let storage of stockStorageData?.storages"
      class="flex px-4 py-3 items-center justify-between w-full text-sm border-b border-b-solid border-b-separator"
      [class.!bg-green-50]="storage?.kzlagerplatz === 'H'">
      <div>{{ storage.title }} {{ storage?.name }}</div>
    </div>
  </div>
</div>-->
  @if (!hideEinheiten()) { @if (data()?.itemStorage && (data()?.itemStorage?.length || 0)
  > 0) {
  <div class="soft-card">
    <cdk-accordion>
      @if (data()?.itemUnitData; as units) {
      <cdk-accordion-item
        role="button"
        tabindex="0"
        #accordionItem="cdkAccordionItem"
        [expanded]="einheitenExpanded()"
        [attr.aria-expanded]="accordionItem.expanded"
        class="flex flex-col"
      >
        <div
          class="font-semibold flex justify-between items-center cursor-pointer"
          (click)="accordionItem.toggle()"
        >
          <h6
            class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide"
          >
            {{ '#ARTIKELINFO.PAGES.DETAIL.UNITS.TITLE' | translate }}
          </h6>
          <div
            class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
          >
            @if (!accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
            } @if (accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
            }
          </div>
        </div>
        <div
          [style.display]="accordionItem.expanded ? 'block' : 'none'"
          class="pt-2 bg-surface"
        >
          <div
            class="flex flex-col bg-surface border-t border-t-solid border-t-separator"
          >
            <div
              class="flex px-4 py-2 items-center w-full border-b border-b-solid border-b-separator bg-surface-secondary"
            >
              <div class="w-2/4 text-[0.825rem] font-semibold">
                {{ '#ARTIKELINFO.PAGES.DETAIL.UNITS.UNIT' | translate }}
              </div>
              <div
                class="w-1/4 text-[0.825rem] font-semibold flex items-center justify-end text-right"
              >
                {{ '#ARTIKELINFO.PAGES.DETAIL.UNITS.FACTOR' | translate }}
              </div>
              <div
                class="w-1/4 text-[0.825rem] font-semibold flex items-center justify-end text-right"
              >
                {{ '#ARTIKELINFO.PAGES.DETAIL.UNITS.WEIGHT' | translate }}
              </div>
            </div>
            @for (unit of units ?? [] | sort: 'factor' : 'ASC'; track unit) {
            <div
              class="flex px-4 py-3 items-center w-full border-b border-b-solid border-b-separator"
            >
              <div class="w-2/4">
                {{ unit?.itemUnit?.name }} @if (unit?.itemUnit?.title &&
                unit?.itemUnit?.title !== '') { - {{ unit?.itemUnit?.title }} }
              </div>
              <div class="w-1/4 font-semibold flex items-center justify-end text-right">
                {{ unit?.factor | number: '1.2-2' }}
              </div>
              <div class="w-1/4 font-semibold flex items-center justify-end text-right">
                {{ unit?.weight | number: '1.2-2' }}
              </div>
            </div>
            }
          </div>
        </div>
      </cdk-accordion-item>
      }
    </cdk-accordion>
  </div>
  } } @if (!hideLieferanten()) { @if (data()?.itemSupplier; as suppliers) {
  <div class="soft-card">
    <cdk-accordion>
      <cdk-accordion-item
        role="button"
        tabindex="0"
        #accordionItem="cdkAccordionItem"
        [expanded]="lieferantenExpanded()"
        [attr.aria-expanded]="accordionItem.expanded"
        class="flex flex-col"
      >
        <div
          class="font-semibold flex justify-between items-center cursor-pointer"
          (click)="accordionItem.toggle()"
        >
          <h6
            class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide"
          >
            {{ '#ARTIKELINFO.PAGES.DETAIL.SUPPLIERS.TITLE' | translate }}
          </h6>
          <div
            class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
          >
            @if (!accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
            } @if (accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
            }
          </div>
        </div>
        <div
          [style.display]="accordionItem.expanded ? 'block' : 'none'"
          class="pt-2 bg-surface"
        >
          <div
            class="flex flex-col bg-surface border-t border-t-solid border-t-separator"
          >
            <div
              class="flex px-4 py-2 items-end justify-between w-full border-b border-b-solid border-b-separator bg-surface-secondary"
            >
              <div class="text-[0.825rem] w-6/12 font-semibold flex flex-col">
                Lieferant
                <span>Lieferant-ArtNr</span>
              </div>
              <div
                class="text-[0.825rem] w-4/12 font-semibold flex items-center justify-end text-right"
              >
                {{ '#ARTIKELINFO.PAGES.DETAIL.SUPPLIERS.MIN_ORDER_AMOUNT' | translate }}
              </div>
              <div
                class="text-[0.825rem] w-2/12 font-semibold flex items-center justify-end text-right"
              >
                {{ '#ARTIKELINFO.PAGES.DETAIL.SUPPLIERS.UNIT' | translate }}
              </div>
            </div>
            @for (supplier of suppliers; track supplier) {
            <div
              [ngClass]="
                          supplier.supplier.kzliefgelistet === 'H' ? 'bg-success-100' : ''
                        "
              class="flex px-4 py-3 items-center justify-between w-full border-b border-b-solid border-b-separator"
            >
              <div class="flex flex-col w-6/12">
                {{ supplier.supplier?.number }} - {{ supplier.supplier?.name }}
                <span class="text-sm text-light">{{ supplier.foreignNumber }}</span>
              </div>
              <div class="font-semibold flex items-center justify-end text-right w-4/12">
                {{ supplier.minAmount | number: '1.2-2' }}
              </div>
              <div class="font-semibold flex text-right items-center justify-end w-2/12">
                {{ supplier?.itemUnit?.name || supplier?.itemUnit?.title }}
              </div>
            </div>
            }
          </div>
        </div>
      </cdk-accordion-item>
    </cdk-accordion>
  </div>
  } }
</div>
